<ion-app>
  <ion-router-outlet main id="first"></ion-router-outlet>
  @if (loading()) {
    <section class="nt-container">
      <div class="nt-loading-shade">
        <ion-spinner name="dots"></ion-spinner>
      </div>
    </section>
  }
</ion-app>